import Helpers from "../../util/Helpers";

export default ({ instance, baseURL, headers}) => {
    const apiCalls = {
        inserirPerfilTribunal(perfilTribunal){
            return instance({
                method: 'post',
                baseURL,
                url: 'PerfilTribunal/CadastrarPerfilTribunal',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(perfilTribunal),
            });
        },
        atualizarPerfilTribunal(perfilTribunal, idUserAlteracao){
            return instance({
                method: 'post',
                baseURL,
                url: 'PerfilTribunal/EditarPerfilTribunal',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(perfilTribunal,idUserAlteracao),
            });
        },
        getPerfilTribunalExibicao(filters){
            return instance({
                method: 'post',
                baseURL,
                url: 'PerfilTribunal/RecuperarPerfilTribunalExibicao',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filters),
            });
        },
        getPerfilTribunalExibicaoUsuario(idUsuario){
            return instance({
                method: 'post',
                baseURL,
                url: 'PerfilTribunal/RecuperarPerfilTribunalUsuario',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({'idUsuario': idUsuario}),
            });
        },
        buscarPerfilTribunalId(id){
            return instance({
                method: 'post',
                baseURL,
                url: 'PerfilTribunal/BuscarPerfilTribunalId',
                responseType: 'json',
                headers: headers,
                data:Helpers.aplicarValidacoes({'Id': id})
            });
        }
    }
    return apiCalls;
}